var _excluded = ["placeholder", "initialSelectedItems", "className", "recentSearchKey", "onLoadedRecentSearches", "inputType", "alwaysOpen", "onEntryClick", "onCloseModal", "pending", "invalid", "extensions"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import ModalPlaceholder from '../components/modal-placeholder';
import useRecentSearches from '../utils/use-recent-searches';
import AutocompleteModal from './autocomplete-modal';
import * as autocompletePropTypes from '../utils/prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ModalWrapper = _ref => {
  var placeholder = _ref.placeholder,
    initialSelectedItems = _ref.initialSelectedItems,
    className = _ref.className,
    recentSearchKey = _ref.recentSearchKey,
    onLoadedRecentSearches = _ref.onLoadedRecentSearches,
    inputType = _ref.inputType,
    alwaysOpen = _ref.alwaysOpen,
    onEntryClick = _ref.onEntryClick,
    onCloseModal = _ref.onCloseModal,
    pending = _ref.pending,
    invalid = _ref.invalid,
    extensions = _ref.extensions,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  useRecentSearches({
    recentSearchKey,
    onLoadedRecentSearches
  });
  var openModal = () => {
    setShow(true);
    onEntryClick();
  };
  var closeModal = () => {
    onCloseModal();
    setShow(false);
  };
  return ___EmotionJSX(Fragment, null, ___EmotionJSX(ModalPlaceholder, {
    placeholder: placeholder,
    hideButton: inputType === 'form-no-button',
    selectedItems: initialSelectedItems,
    onClick: openModal,
    className: className,
    pending: pending,
    invalid: invalid,
    embeddedComponent: extensions === null || extensions === void 0 ? void 0 : extensions.placeholder
  }), (show || alwaysOpen) && ___EmotionJSX(AutocompleteModal, _extends({}, props, {
    hideButton: inputType === 'form-no-button',
    recentSearchKey: recentSearchKey,
    initialSelectedItems: initialSelectedItems,
    placeholder: placeholder,
    extensions: extensions,
    closeModal: closeModal
  })));
};
ModalWrapper.propTypes = {
  placeholder: PropTypes.string,
  inputType: autocompletePropTypes.inputType,
  initialSelectedItems: PropTypes.arrayOf(PropTypes.shape({})),
  extensions: PropTypes.shape({
    placeholder: PropTypes.node,
    suggestionSheet: PropTypes.node,
    suggestionHeading: PropTypes.node
  }),
  alwaysOpen: PropTypes.bool,
  pending: PropTypes.bool,
  invalid: PropTypes.bool,
  recentSearchKey: PropTypes.string,
  onLoadedRecentSearches: PropTypes.func,
  onCloseModal: PropTypes.func,
  onEntryClick: PropTypes.func,
  className: PropTypes.string
};
ModalWrapper.defaultProps = {
  placeholder: '',
  inputType: 'standalone',
  extensions: undefined,
  initialSelectedItems: [],
  alwaysOpen: false,
  pending: false,
  invalid: false,
  recentSearchKey: undefined,
  onLoadedRecentSearches: undefined,
  onCloseModal: () => {},
  onEntryClick: () => {},
  className: ''
};
export default ModalWrapper;